import React from "react";
import LibraryChapter from "./LibraryChapter";
import { Link, NavLink } from "react-router-dom";

export default function LibraryChapterProps({ data, subIndex }) {
  console.log(data);
  return (
    <div className="chapterBox">
      {data.chapterData.length > 0 && data.chapterData.map((obj, index) => (
        <NavLink to={`/chapterContent`} className="link" state={{ chapter_id: obj.id, subIndex: subIndex }}>
          <LibraryChapter
            chapterNo={obj.chapterName}
            StudyMaterial={`${obj.countMaterials} Study Material`}
            chapterImg="/ContentM_images/chapter1.svg"
            indexNo={index}
          />
        </NavLink>
      ))}
    </div>
  );
}
